import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { Icon, Input, Label } from 'semantic-ui-react';
import { useStore } from '../../stores/store';
import '../MediaQuery/responsive-asset-list.css';
import { userLanguage } from '../userLanguageSchema/userLanguage';
import QrModal from './QrModal';
interface searchCategory {
  filterStyle?: boolean;
}
export default observer(function Search({ filterStyle }: searchCategory) {
  const { activityStore, modalStore, commonStore } = useStore();
  const inputRef = useCallback((node: any) => {
    node?.focus();
  }, []);
  const load: boolean = false;

  const onChangeHandler = (_event: any, { value }: { value: string }) => {
    // if (activityStore.Filter?.length === 0 || value.length === 0) {
    //   activityStore.FilterCategory = "";
    // }
    activityStore.Filter = value || '';
  };

  return (
    <div className={filterStyle ? 'inputsearch' : ''}>
      <Input
        labelPosition="right"
        icon="qrcode"
        placeholder={
          (userLanguage[0].AssetViewItemLevelListPage.AVISTB01 as any)?.[
            `${commonStore.language.key}`
          ]
        } //'Search...'
        fluid
        loading={load}
        value={activityStore.Filter}
        // onChange={(event) => activityStore.setFilterId(event.target.value)}>
        onChange={onChangeHandler}
      >
        <input ref={inputRef} />
        {activityStore.Filter ? (
          <Label onClick={() => (activityStore.Filter = '')}>
            <Icon
              name="cancel"
              style={{
                alignItems: 'center',
                justifyContent: 'center',
              }}
            />
          </Label>
        ) : (
          <Label
            onClick={() =>
              modalStore.openSmallModal(
                <>
                  <QrModal />
                </>,
              )
            }
          >
            <Icon
              name="qrcode"
              style={{
                alignItems: 'center',
                justifyContent: 'center',
              }}
            />
          </Label>
        )}
      </Input>
    </div>
  );
});
